// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"86fdef4f","171":"35d08765","676":"84609ea6","837":"2bd9f533"}[chunkId] + ".chunk.css";
};